import catalogData from 'bundles/catalogP/api/api.promise';
import catalogUrl from 'bundles/catalogP/lib/catalogUrl';
import S12n from 'bundles/catalogP/models/s12n';

export default function (options: $TSFixMe) {
  return catalogData(catalogUrl.build(S12n.prototype.resourceName, options));
}
